'use client';
import React, {useRef, useEffect, useState, MutableRefObject, CSSProperties} from 'react';
import scrollContainerStyles from "./scroll-container.module.css"

function ScrollContainer({children, style}: { children: React.ReactNode, style?: CSSProperties, grow?: boolean }) {
    const containerRef = useRef<HTMLDivElement>(null);
    const [isTop, setIsTop] = useState(true);
    const [isBottom, setIsBottom] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (containerRef.current) {
                setIsTop(containerRef.current.scrollTop === 0);
                setIsBottom(
                    containerRef.current.scrollTop + containerRef.current.clientHeight === containerRef.current.scrollHeight
                );
            }
        };

        containerRef.current?.addEventListener('scroll', handleScroll);
        return () => containerRef.current?.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={scrollContainerStyles.fadeScrollWrapper} style={style}>
            <div ref={containerRef} className={scrollContainerStyles.fadeScrollContent}>
                {children}
            </div>
        </div>
    );
}

export default ScrollContainer;
